export const DOWNLOAD_ACCOUNT_USERS_TEXT = {
    id: 'oe.accountUsers.downloadAccountUsers',
    defaultMessage: 'Download Account Users',
    description: 'Button text',
};